import { Fragment, useContext, useMemo } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import cn from 'classnames'
import BrandingContext from '../context/BrandingContext'

const Dropdown = (props) => {
  const { buttonText, items, renderButton, className } = props
  const [branding] = useContext(BrandingContext)
  const { primaryColorPalette } = branding

  const itemsJsx = useMemo(() => {
    const renderItem = (item) => {
      const {
        label,
        icon,
        renderItem: renderCustomItem,
        disabled,
        as: Component = 'button',
        ...rest
      } = item

      if (renderCustomItem) {
        return (
          <Menu.Item disabled={disabled} key={label || `${Math.random()}`}>
            {renderCustomItem()}
          </Menu.Item>
        )
      }

      return (
        <Menu.Item disabled={disabled} key={label}>
          {({ active }) => {
            const className = cn(
              'group flex w-full items-center rounded-md px-3 py-2 text-sm',
              {
                [`bg-${primaryColorPalette}-600 text-white`]: active,
                'text-gray-900': !active,
              },
            )

            const iconClassName = cn('mr-3 w-6 h-auto', {
              [`text-${primaryColorPalette}-500`]: !active,
              'text-white': active,
            })

            return (
              <Component className={className} {...rest}>
                {icon && (
                  <FontAwesomeIcon icon={icon} className={iconClassName} />
                )}
                {label}
              </Component>
            )
          }}
        </Menu.Item>
      )
    }

    return items.map((item, index) => {
      if (Array.isArray(item)) {
        const itemsJsx = item.map(renderItem)
        return (
          <div className="px-1 py-1" key={index}>
            {itemsJsx}
          </div>
        )
      }

      return (
        <div className="px-1 py-1" key={index}>
          {renderItem(item)}
        </div>
      )
    })
  }, [items, primaryColorPalette])

  return (
    <Menu as="div" className={cn('relative inline-block text-left', className)}>
      <div>
        {renderButton ? (
          renderButton({ MenuButton: Menu.Button })
        ) : (
          <Menu.Button className="inline-flex w-full justify-center rounded-md bg-black/20 px-4 py-2 text-sm font-medium text-white hover:bg-black/30 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-white/75">
            {buttonText}
            <FontAwesomeIcon
              icon={faChevronDown}
              className={`ml-2 -mr-1 h-5 w-5 text-${primaryColorPalette}-200 hover:text-${primaryColorPalette}-100`}
              aria-hidden="true"
              size="md"
            />
          </Menu.Button>
        )}
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-2 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md border border-gray-200 bg-white shadow-lg focus:outline-hidden">
          {itemsJsx}
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export default Dropdown
